import React, { useRef, useState, useLayoutEffect } from "react";
import { any, bool, string } from "prop-types";
import * as style from "./styles.module.scss";

const OverflowedText = ({
  className = "",
  overflowedText = "",
  children,
  forceOverflow = false,
  styles = {},
}) => {
  const overflowedElement = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  useLayoutEffect(() => {
    if (
      overflowedElement.current.scrollWidth >
        overflowedElement.current.offsetWidth ||
      forceOverflow
    ) {
      setShowTooltip(true);
    }
  }, [overflowedElement.current]);

  return (
    <div
      className={`${className} ${style.overflowedText}`}
      ref={overflowedElement}
      style={styles}
    >
      <span>{children}</span>
      <span
        className={`${style.overflowedText__arrow} ${!showTooltip && "d-none"}`}
      ></span>
      <span
        className={`${style.overflowedText__tooltip} ${
          !showTooltip && "d-none"
        }`}
        id="overflowedTextInner"
      >
        {overflowedText}
      </span>
    </div>
  );
};

OverflowedText.propTypes = {
  className: string,
  overflowedText: string.isRequired,
  children: string.isRequired,
  forceOverflow: bool,
  styles: any,
};

export default OverflowedText;
